import service from '@/services/SIRcon_aut_pdf';

export default {
  namespaced: true,

  actions: {
    send({ dispatch, rootGetters }, value) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRcon_aut_pdf: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRcon_aut_pdf: [
              {
                piidoc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0,
                piccod_otpt: value.otpCode,
                picaut_mail: value.email,
                piicrd_est: 99,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRcon_aut_pdf;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
